module.exports = __webpack_public_path__ + "img/right.983d62e0.svg";